import { BarChart } from '../../../renderers/bar-chart/bar-chart.component';
import { ChartRendererProps } from '../../../types/chart-renderer-props';
import { TRANSACTION_VOLUME_BY_CUSTOMER_BAR_CHART_DEFINITION } from './transaction-volume-by-customer-bar-chart.definition';
import { TRANSACTION_VOLUME_BY_CUSTOMER_BAR_CHART_MOCK_DATA } from './transaction-volume-by-customer-bar-chart.mock';

export const TransactionVolumeByCustomerBarChart = (props: ChartRendererProps) => <BarChart {...props} />;

TransactionVolumeByCustomerBarChart.definition = TRANSACTION_VOLUME_BY_CUSTOMER_BAR_CHART_DEFINITION;
TransactionVolumeByCustomerBarChart.mockData = TRANSACTION_VOLUME_BY_CUSTOMER_BAR_CHART_MOCK_DATA;
